import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { phaseChange, reroute } from '../../../../actions/Buy'
import {
  findomesticCheckBoxAssicurazioni,
  postContratti,
} from '../../../../actions/buy/Findomestic'
import {
  getFinanziamentoAssicurato,
  getFinanziamentoNonAssicurato,
  validaCheckBoxes,
} from '../../../../utils/firmaUtils'
import OrderRecoveryBanner from '../../../dumb/OrderRecoveryBanner'
import BuyButton from '../../dumb/BuyButton'
import BuyMiniCart from '../../dumb/BuyMiniCart'
import CheckBoxes from '../../dumb/FindomesticFirmaDigitale/CheckBoxes'
import Links from '../../dumb/FindomesticFirmaDigitale/Links'
import { preparaValoriLogistica, proxifyEcreditUrl } from '../../utils'

class FindomesticServiziAssicurativi extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checkBoxErrors: {},
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 140 })
    if (!this.props.findomestic.firmaAssicurazioni.length) {
      // non ho assicurazioni da firmare
      if (!this.props.isV2) {
        this.props.reroute('/firma-digitale')
      } else {
        this.props.reroute('/v2/firma-digitale')
      }
    }
  }

  handleSubmit() {
    const t = this
    return () => {
      if (
        validaCheckBoxes(
          this.props.findomestic.firmaAssicurazioniCheckBoxes,
          t.state.checkBoxErrors,
          checkBoxErrors => t.setState(checkBoxErrors)
        )
      ) {
        if (!t.props.isV2) {
          t.props.reroute('/firma-digitale')
        } else {
          t.props.reroute('/v2/firma-digitale')
        }
      }
    }
  }

  render() {
    const { product } = this.props
    const valoriLogistica = preparaValoriLogistica(
      this.props.pricing.total,
      this.props.logistica
    )
    const h1 =
      'Firma Digitale: sottoscrivi i documenti per i servizi assicurativi selezionati'
    return (
      <div className="FindomesticInfocertFirma sellout-findomestic">
        <section
          className="relative process"
          id={'FindomesticServiziAssicurativi'}
        >
          <div className="process__header">
            <h1 className="process__title">{h1}</h1>
          </div>
          <div className={'messages warning'}>
            <div className={'container'}>
              <OrderRecoveryBanner />
            </div>
          </div>
          <div className="user-informations">
            <div className="container_small">
              <div className="process__column process__column__left">
                <h1>Firma Servizi Assicurativi Findomestic</h1>
                <p>
                  Scarica il contratto per prenderne visione e salvarlo sul tuo
                  dispositivo. Accetta le condizioni spuntando le caselle
                  corrispondenti.
                </p>
                {this.props.findomestic.firmaAssicurazioni.map(ass => {
                  const currentCheckBoxes = Object.values(
                    this.props.findomestic.firmaAssicurazioniCheckBoxes
                  ).reduce((acc, el) => {
                    if (el.key.indexOf(ass.key) === 0) {
                      acc[el.key] = el
                    }

                    return acc
                  }, {})
                  return (
                    <div key={ass.key}>
                      <div className="space-50"></div>
                      <h2>{ass.titolo}</h2>
                      <div className={'scarica-contratto'}>
                        <Links
                          links={[
                            {
                              title: 'Informativa',
                              text: 'Informativa',
                              href: proxifyEcreditUrl(ass.link_informativa),
                            },
                            {
                              title: ass.links[0].title,
                              text: ass.links[0].text,
                              href: proxifyEcreditUrl(ass.links[0].href),
                            },
                          ]}
                        />
                      </div>
                      <div className="space-20"></div>
                      <CheckBoxes
                        checkBoxErrors={this.state.checkBoxErrors}
                        checkBoxOnChangeAction={
                          this.props.findomesticCheckBoxAssicurazioni
                        }
                        checkBoxes={currentCheckBoxes}
                      />
                    </div>
                  )
                })}
                <div className={'buttons_set center no-brd more-pd'}>
                  <BuyButton
                    classes={`btn btn-primary ${
                      this.props.fetching ? ' btn-disabled' : ''
                    }`}
                    label={'Prosegui'}
                    update={this.handleSubmit()}
                  />
                </div>
              </div>
              <div className="process__column process__column__right">
                <BuyMiniCart
                  {...valoriLogistica}
                  acconti={this.props.ordine.acconti}
                  agevolazione_iva_104={
                    this.props.customer.agevolazione_iva_104
                  }
                  finanziamento={getFinanziamentoAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  finanziamentoNonAssicurato={getFinanziamentoNonAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  idAuto={product.id_auto}
                  km={product.km}
                  ordine={this.props.ordine}
                  ownership={product.passaggio_proprieta_totale_generale}
                  paymentMethod={this.props.paymentMethod}
                  price={product.prezzo_sellout}
                  product={product}
                  sconto={this.props.ordine.sconto}
                  serviziAssicurativiSelezionati={
                    this.props.findomestic.servizi_assicurativi_selezionati
                  }
                  totalone={this.props.ordine.totale}
                  year={product.anno}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

FindomesticServiziAssicurativi.defaultProps = {
  isV2: false,
}

FindomesticServiziAssicurativi.propTypes = {
  product: PropTypes.object,
  ordine: PropTypes.object,
  pricing: PropTypes.object,
  logistica: PropTypes.object,
  fetching: PropTypes.bool,
  customer: PropTypes.object,
  findomestic: PropTypes.object,
  reroute: PropTypes.func,
  phaseChange: PropTypes.func,
  postContratti: PropTypes.func,
  findomesticCheckBoxAssicurazioni: PropTypes.func,
  paymentMethod: PropTypes.string,
  financements: PropTypes.object,
  isV2: PropTypes.bool,
}

const mapStateToProps = state => ({
  pricing: state.pricing,
  product: state.product,
  ordine: state.ordine,
  findomestic: state.findomestic,
  logistica: state.logistica,
  customer: state.customer,
  fetching: state.ui.fetching,
  paymentMethod: state.payment.method,
  financements: state.financements,
})

const mapDispatchToProps = dispatch => ({
  reroute: payload => dispatch(reroute(payload)),
  phaseChange: payload => dispatch(phaseChange(payload)),
  findomesticCheckBoxAssicurazioni: payload =>
    dispatch(findomesticCheckBoxAssicurazioni(payload)),
  postContratti: () => dispatch(postContratti),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FindomesticServiziAssicurativi)
